<template>
  <el-upload
    drag
    action="#"
    :http-request="selectFile"
    :show-file-list="false"
    accept=".csv"
  >
    <i class="el-icon-upload"></i>
    <div class="el-upload__text">
      Drop file here or <em>click to upload</em>
    </div>
  </el-upload>
</template>

<script>
import { projectEndpoint } from '@/core/helpers'
import RestApi from '@/core/services/RestApi'

export default {
  name: 'CsvUpload',

  props: {
    loading: {
      type: Boolean,
      required: true
    },

    columns: {
      type: Array,
      required: true
    }
  },

  computed: {
    previewEndpoint() {
      return projectEndpoint({
        url: `imports/preview`
      })
    },

    uploadEndpoint() {
      return projectEndpoint({
        method: 'post',
        url: `imports/upload`,
        config: { headers: { 'Content-Type': 'multipart/form-data' } }
      })
    }
  },

  methods: {
    async selectFile(options) {
      this.$emit('init')
      await this.uploadFile(options.file)
    },

    uploadFile(file) {
      this.$emit('update:loading', true)
      const formData = new FormData()
      formData.append('file', file)
      RestApi({
        ...this.uploadEndpoint,
        ...{ data: formData }
      })
        .then(({ data }) => {
          this.getMappings(data.file_id)
        })
        .catch(error => {
          this.$emit('update:loading', false)
          this.$message({
            message: error.message,
            type: 'error'
          })
        })
    },

    getMappings(fileId) {
      RestApi.post(this.previewEndpoint.url, {
        type: 'upload',
        file_id: fileId
      })
        .then(({ data }) => {
          this.$emit('update:columns', data.columns)
          this.$emit('update:file-id', fileId)
          this.$emit('update:loading', false)
          this.$message({
            message: this.$t('Imports_Message_UploadedSuccessfully'),
            type: 'success'
          })
        })
        .catch(error => {
          this.$emit('update:loading', false)
          this.$message({
            message: error.message,
            type: 'error'
          })
        })
    }
  }
}
</script>

<style scoped>
>>> .el-upload-dragger .el-icon-upload {
  line-height: 0;
}

>>> .el-upload-dragger {
  display: flex;
  align-items: center;
  height: 40px;
}

>>> .el-upload-dragger:hover {
  border-color: #a7acba;
}

>>> .el-upload-dragger .el-icon-upload {
  font-size: 30px;
}

>>> .el-upload-dragger .el-icon-upload {
  margin: 0px 20px 0px 20px;
}

>>> .el-upload-dragger .el-upload__text {
  color: #a7acba;
}

>>> .el-upload-dragger .el-upload__text em {
  color: #1c87c8;
  font-style: normal;
}
</style>



// WEBPACK FOOTER //
// src/modules/imports/components/CsvUpload.vue